import styled from 'styled-components'
import { Box } from 'src/components'
import { motion } from 'framer-motion'

export const SectionTypography = styled(motion(Box))`
    width: 90%;

    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 322.67px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 472.67px;
        display: flex;
    }
`
export const OverMap = styled(Box)<{
    address: boolean
}>`
    display: flex;
    width: 100%;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: ${({ address }) => (address ? 'row' : 'row-reverse')};
        width: 98%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: ${({ address }) => (address ? 'row' : 'row-reverse')};
        width: 1280px;
    }
`
export const SectionTypographyResponsive = styled(motion(Box))`
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 322.67px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 472.67px;
        display: none;
    }
`
export const SectionImage = styled(motion.img)`
    width: 320px;
    height: 231px;
    display: none;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 370px;
        height: 280px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 50%;
        height: 431px;
        border-radius: 20px;
        display: flex;
    }
`
export const SectionImageResponsive = styled(motion.img)`
    width: 320px;
    height: 231px;
    display: flex;
    border-radius: 20px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 370px;
        height: 280px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 520px;
        height: 431px;
        display: none;
    }
`
